import { cn } from "@/lib/utils";

const Shimmer = ({ className }: { className?: string }) => (
  <div className={cn("relative overflow-hidden rounded-md bg-muted", className)}>
    <div className="absolute inset-0 -translate-x-full animate-[blogShimmer_1.4s_infinite] bg-gradient-to-l from-transparent via-foreground/10 to-transparent" />
  </div>
);

export function BlogListSkeleton() {
  return (
    <div className="fade-in mx-auto max-w-7xl px-4 py-10 sm:px-6">
      <style>{`@keyframes blogShimmer { 100% { transform: translateX(100%); } }`}</style>
      <div className="mb-10 space-y-4 text-center">
        <Shimmer className="mx-auto h-4 w-32" />
        <Shimmer className="mx-auto h-10 w-2/3" />
        <Shimmer className="mx-auto h-4 w-1/2" />
      </div>
      <div className="mb-10 overflow-hidden rounded-3xl border border-border">
        <div className="grid lg:grid-cols-2">
          <Shimmer className="aspect-[16/10] rounded-none lg:aspect-auto" />
          <div className="space-y-4 p-8">
            <Shimmer className="h-3 w-20" />
            <Shimmer className="h-8 w-full" />
            <Shimmer className="h-8 w-3/4" />
            <Shimmer className="h-3 w-full" />
            <Shimmer className="h-3 w-5/6" />
            <div className="flex gap-3 pt-2">
              <Shimmer className="h-7 w-7 rounded-full" />
              <Shimmer className="h-3 w-32" />
            </div>
          </div>
        </div>
      </div>
      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {Array.from({ length: 6 }).map((_, i) => (
          <div key={i} className="overflow-hidden rounded-2xl border border-border">
            <Shimmer className="aspect-[16/10] rounded-none" />
            <div className="space-y-3 p-5">
              <Shimmer className="h-5 w-full" />
              <Shimmer className="h-5 w-3/4" />
              <Shimmer className="h-3 w-full" />
              <Shimmer className="h-3 w-5/6" />
              <div className="flex justify-between pt-2">
                <Shimmer className="h-3 w-20" />
                <Shimmer className="h-3 w-12" />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function BlogPostSkeleton() {
  return (
    <div className="fade-in mx-auto max-w-3xl px-4 py-10 sm:px-6">
      <style>{`@keyframes blogShimmer { 100% { transform: translateX(100%); } }`}</style>
      <Shimmer className="mb-4 h-3 w-32" />
      <Shimmer className="mb-3 h-10 w-full" />
      <Shimmer className="mb-3 h-10 w-3/4" />
      <div className="my-6 flex items-center gap-3">
        <Shimmer className="h-10 w-10 rounded-full" />
        <Shimmer className="h-3 w-40" />
      </div>
      <Shimmer className="mb-8 aspect-[16/9] w-full rounded-2xl" />
      <div className="space-y-3">
        {Array.from({ length: 12 }).map((_, i) => (
          <Shimmer key={i} className={`h-4 ${i % 4 === 3 ? "w-2/3" : "w-full"}`} />
        ))}
      </div>
    </div>
  );
}
